import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Carousel } from '@codex-brightworld/components';

import VideoLink from './VideoLink/VideoLink';
import ProductThumbnailImagesCarousel
  from './ProductThumbnailImagesCarousel/ProductThumbnailImagesCarousel';
import AnimatedMessage from './AnimatedMessage/AnimatedMessage';
import ZoomableImage from './ZoomableImage/ZoomableImage';


const StickerImage = styled.img`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  z-index: 1;
  width: auto;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
`;

const ProductImagesSection = ({
  displayCompareCheckbox, displayVideoLink, videoLinkLabel,
  productImage, stickerImageURL, galleryImages, animatedMessageData
}) => {

  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);

  return (
    <>
      {typeof stickerImageURL === 'string' && (
        <StickerImage src={stickerImageURL} alt={'product sticker'} />
      )}
      {typeof galleryImages !== 'undefined'
        ? (
          <Carousel
            showNavigation={false}
            showArrowButtons={false}
            selectSlideIndex={selectedImageIndex}
            onSelectedSlideChanged={(selectedSlideIndex) => {
              setSelectedImageIndex(selectedSlideIndex);
            }}
          >
            {galleryImages.map((galleryImage, index) => (
              <ZoomableImage
                src={galleryImage.srcLarge}
                alt={productImage.alt}
                key={index}
              />
            ))}
          </Carousel>
        )
        : (
          /* if gallery images are not defined only the product image with zoom is rendered */
          <ZoomableImage
            src={productImage.src}
            alt={productImage.alt}
          />
        )}
      {displayVideoLink && (
        <VideoLink videoLinkLabel={videoLinkLabel} />
      )}
      {typeof galleryImages !== 'undefined' && (
        <ProductThumbnailImagesCarousel
          galleryImages={galleryImages}
          selectedImageIndex={selectedImageIndex}
          selectedSlideIndex={selectedSlideIndex}
          onProductImageClick={(clickedProductImageIndex) => {
            setSelectedImageIndex(clickedProductImageIndex);
          }}
          onSelectedSlideChanged={(selectedSlideIndex) => {
            setSelectedSlideIndex(selectedSlideIndex);
          }}
        />
      )}
      {typeof animatedMessageData !== 'undefined' && (
        <AnimatedMessage {...animatedMessageData} />
      )}
    </>
  );
};

ProductImagesSection.propTypes = {
  displayCompareCheckbox: PropTypes.bool.isRequired,
  displayVideoLink: PropTypes.bool.isRequired,
  videoLinkLabel: PropTypes.string.isRequired,
  productImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }).isRequired,
  stickerImageURL: PropTypes.string,
  galleryImages: PropTypes.arrayOf(PropTypes.shape({
    srcLarge: PropTypes.string.isRequired,
    srcSmall: PropTypes.string.isRequired
  })),
  animatedMessageData: PropTypes.shape({
    iconType: PropTypes.oneOf(['eye', 'fire']).isRequired,
    message: PropTypes.string.isRequired,
    delay: PropTypes.string.isRequired,
    timeout: PropTypes.string.isRequired,
    valueTrimmed: PropTypes.string.isRequired,
    min: PropTypes.string.isRequired,
    max: PropTypes.string.isRequired
  })
};

ProductImagesSection.defaultProps = {
  stickerImageURL: undefined,
  galleryImages: undefined,
  animatedMessageData: undefined
};

export default ProductImagesSection;
